import { apiService } from '../../shared/services/apiService';
import { RecipeDetails } from '../interfaces/RecipeDetails';
import { RecipeListItem } from '../interfaces/RecipeListItem';
import { RecipesFilters } from '../interfaces/RecipesFilters';

export type GetRecipesResponse = {
  items: RecipeListItem[];
  page: {
    count: number;
  };
  totalElements: number;
};

export const recipesService = {
  async getRecipes({ requestedPage }: RecipesFilters): Promise<GetRecipesResponse> {
    const params = { page: requestedPage.page, limit: requestedPage.size, owners: 'all' };

    const resp = await apiService.get<GetRecipesResponse>('api/recipes', {
      params,
    });

    return resp.data;
  },

  async changeRecipeState(recipeId: number, ban: boolean): Promise<void> {
    await apiService.post(`api/recipe/${recipeId}/ban`, null, {
      params: { ban },
    });
  },

  async deleteRecipe(recipeId: number): Promise<void> {
    await apiService.delete(`api/recipe/${recipeId}`);
  },

  async getRecipe(recipeId: number): Promise<RecipeDetails> {
    const resp = await apiService.get<RecipeDetails>(`api/recipe/${recipeId}`);

    return resp.data;
  },

  /** `formData` carries the `SaveRecipeRequest` fields */
  async createRecipe(formData: FormData): Promise<RecipeDetails> {
    const resp = await apiService.post<RecipeDetails>('api/recipe', formData);

    return resp.data;
  },

  // a recipe the caller cannot edit is copied, not edited - the response then carries the copy's id
  async updateRecipe(formData: FormData): Promise<RecipeDetails> {
    const resp = await apiService.put<RecipeDetails>('api/recipe', formData);

    return resp.data;
  },
};
